import styled, { useTheme } from 'styled-components'
import { CouponUnavailableReasonEnum, EstimateCartResponseDtoExcludedCouponsItem } from '@/apis/rest/generated/types'
import Modal from '@/components/common/modals/Modal'
import { Typo, TypoVariant } from '@/components/common/typography'

interface CartUnApplyCouponWithAmountModalProps {
  excludedCoupons: EstimateCartResponseDtoExcludedCouponsItem[]
  onConfirm: (couponId: number[]) => void
}
export const CartUnApplyCouponWithAmountModal = ({
  excludedCoupons,
  onConfirm,
}: CartUnApplyCouponWithAmountModalProps) => {
  const { color } = useTheme()

  const unValidCouponId = excludedCoupons
    .filter(({ reason }) => reason === CouponUnavailableReasonEnum.LESS_THAN_MIN_AMOUNT)
    .flatMap(({ groups }) => groups.map(({ id }) => id))[0]

  const handleClickOk = () => {
    onConfirm([unValidCouponId])
  }

  if (!unValidCouponId) {
    return null
  }

  return (
    <Modal open={true}>
      <Modal.Content>
        <Modal.Title>
          <Typo variant={TypoVariant.Heading6Bold}>
            옵션 및 수량 변경으로 <br /> 할인 적용이 취소되었어요
          </Typo>
        </Modal.Title>
        <Modal.SubTitle>
          <Typo variant={TypoVariant.Body3Regular}>최소주문금액 부족으로 쿠폰을 사용할 수 없어요</Typo>
        </Modal.SubTitle>
      </Modal.Content>
      <Modal.Footer>
        <ModalButton className="ok" onClick={handleClickOk}>
          <Typo variant={TypoVariant.Body1Bold} color={color.grayWhite}>
            확인
          </Typo>
        </ModalButton>
      </Modal.Footer>
    </Modal>
  )
}

const ModalButton = styled.button`
  flex: 1;
  border-radius: 0.8rem;
  border: 0.1rem solid;
  padding: 1.3rem 1.6rem;
  cursor: pointer;
  width: 100%;

  &.ok {
    border-color: ${({ theme }) => theme.color.blue500};
    background-color: ${({ theme }) => theme.color.blue500};
  }
`
